export default "__VITE_ASSET__BWe2SR5f__"